import { TOCBUYORSELL } from "@domains/features/TOCJourney/entities/ICommonTOCEntities";
import Commodity from "./Commodity/Commodity";
import Currency from "./Currency/Currency";
import EqBuySellStock from "./Equity/EqBuySellStock";
import FnOBuySellStock from "./FnO/FnOBuySellStock";
export var ETocRoutes;
(function (ETocRoutes) {
    ETocRoutes["Equity_Toc"] = "/buy-stock";
    ETocRoutes["Fno_Toc"] = "/fno";
    ETocRoutes["Esip_Toc"] = "/esip";
    ETocRoutes["Currency_Toc"] = "/currency";
    ETocRoutes["Commodity_Toc"] = "/commodity";
    ETocRoutes["Nfo_Toc"] = "/nfo";
    ETocRoutes["MF_Toc"] = "/mutualfund";
    ETocRoutes["Ncd_Toc"] = "/ncd";
})(ETocRoutes || (ETocRoutes = {}));
export const commonConverList = [
    { display: "Buy Order", value: TOCBUYORSELL.BUY },
    { display: "Sell Order", value: TOCBUYORSELL.SELL },
    { display: "Start ESIP", value: TOCBUYORSELL.SIP },
];
export const tocRoutes = [
    {
        type: "FUTCOM",
        route: ETocRoutes.Commodity_Toc,
        component: Commodity,
    },
    { type: "FUTCUR", route: ETocRoutes.Currency_Toc, component: Currency },
    { type: "FUTIDX", route: ETocRoutes.Fno_Toc, component: FnOBuySellStock },
    { type: "FUTSTK", route: ETocRoutes.Fno_Toc, component: FnOBuySellStock },
    { type: "INDEX", route: ETocRoutes.Equity_Toc, component: EqBuySellStock },
    { type: "OPTCUR", route: ETocRoutes.Currency_Toc, component: Currency },
    { type: "OPTFUT", route: ETocRoutes.Fno_Toc, component: FnOBuySellStock },
    { type: "OPTIDX", route: ETocRoutes.Fno_Toc, component: FnOBuySellStock },
    { type: "OPTSTK", route: ETocRoutes.Fno_Toc, component: FnOBuySellStock },
    { type: "EQUITY", route: ETocRoutes.Equity_Toc, component: EqBuySellStock },
];
export var ITradeValuesENUM;
(function (ITradeValuesENUM) {
    ITradeValuesENUM["amount"] = "amount";
    ITradeValuesENUM["limitPrice"] = "limitPrice";
    ITradeValuesENUM["stopLoss"] = "stopLoss";
    ITradeValuesENUM["target"] = "target";
    ITradeValuesENUM["triggerPrice"] = "triggerPrice";
    ITradeValuesENUM["disclosedQuantity"] = "disclosedQuantity";
    ITradeValuesENUM["quantity"] = "quantity";
    ITradeValuesENUM["totalperiod"] = "totalperiod";
    ITradeValuesENUM["startDate"] = "startDate";
})(ITradeValuesENUM || (ITradeValuesENUM = {}));
export var ITOCScreenStateEnum;
(function (ITOCScreenStateEnum) {
    ITOCScreenStateEnum["ORDER_CONFIRM"] = "ORDER_CONFIRM";
    ITOCScreenStateEnum["INSUFFICIENT_FUND"] = "INSUFFICIENT_FUND";
    ITOCScreenStateEnum["REJECTED_ORDER"] = "REJECTED_ORDER";
    ITOCScreenStateEnum["SUCCESS_ORDER"] = "SUCCESS_ORDER";
    ITOCScreenStateEnum["MARKET_DEPTH"] = "MARKET_DEPTH";
    ITOCScreenStateEnum["CHART_IQ"] = "CHART_IQ";
})(ITOCScreenStateEnum || (ITOCScreenStateEnum = {}));
export const checkTocState = (data, type) => {
    return data === type;
};
export const splitVal = (val) => {
    return val.split(".");
};
export const declarationMsg = {
    esipNrmlConsent: `Note: All E-SIP orders will be placed under "Delivery Plus (NRML)" product type. On E-SIP due date, system will consider total limits available for order placement including stocks collateral. The debit (if any) post the E-SIP order placement will have to be cleared within 5 days post the settlement day to avoid liquidation`,
};
const BO_TAndC = "https://www.nuvamawealth.com/ewwebimages/webfiles/disclaimer/Bracket%20order%20-%20Terms%20and%20Conditions.pdf";
const Esip_link = "https://www.nuvamawealth.com/ewwebimages/webfiles/disclaimer/esip-tc.pdf";
export const redircetToTermeAndCond = (isEsip) => {
    let link = isEsip ? Esip_link : BO_TAndC;
    return window.open(link, "_blank");
};
export const getProductValues = (buttonList, productBtn) => {
    var _a;
    return (_a = buttonList === null || buttonList === void 0 ? void 0 : buttonList.find((x) => x.title === productBtn)) === null || _a === void 0 ? void 0 : _a.mainVal;
};
export const validateTickSize = (price, tickSize) => {
    var _a, _b, _c, _d;
    let intOfPrice = parseInt(price);
    let intOfTickSize = parseInt(tickSize);
    if (parseFloat(tickSize) !== 0) {
        let lenOfPriceAfterDecimal = 0; // l1
        let lenOfTickSizeAfterDecimal = 0; // l2
        let valOfPriceAfterDecimal = 0; // dec1
        let valOfTickSizeAfterDecimal = 0; // dec2
        if (((_a = splitVal(price)) === null || _a === void 0 ? void 0 : _a.length) > 1) {
            lenOfPriceAfterDecimal = (_b = splitVal(price)[1]) === null || _b === void 0 ? void 0 : _b.length;
            valOfPriceAfterDecimal = Number(splitVal(price)[1]);
        }
        if (((_c = splitVal(tickSize)) === null || _c === void 0 ? void 0 : _c.length) > 1) {
            lenOfTickSizeAfterDecimal = (_d = splitVal(tickSize)[1]) === null || _d === void 0 ? void 0 : _d.length;
            valOfTickSizeAfterDecimal = Number(splitVal(tickSize)[1]);
        }
        let graterLenOfDecimalVal = lenOfPriceAfterDecimal;
        if (lenOfPriceAfterDecimal < lenOfTickSizeAfterDecimal)
            graterLenOfDecimalVal = lenOfTickSizeAfterDecimal;
        let powOfGraterLenOfDecimalVal = Math.pow(10, graterLenOfDecimalVal);
        if (powOfGraterLenOfDecimalVal > 1) {
            if (lenOfPriceAfterDecimal <= graterLenOfDecimalVal) {
                valOfPriceAfterDecimal =
                    valOfPriceAfterDecimal *
                        Math.pow(10, graterLenOfDecimalVal - lenOfPriceAfterDecimal);
                intOfPrice =
                    intOfPrice * powOfGraterLenOfDecimalVal + valOfPriceAfterDecimal;
            }
            if (lenOfTickSizeAfterDecimal <= graterLenOfDecimalVal) {
                valOfTickSizeAfterDecimal =
                    valOfTickSizeAfterDecimal *
                        Math.pow(10, graterLenOfDecimalVal - lenOfTickSizeAfterDecimal);
                intOfTickSize =
                    intOfTickSize * powOfGraterLenOfDecimalVal +
                        valOfTickSizeAfterDecimal;
            }
        }
        if (intOfPrice % intOfTickSize == 0) {
            return false;
        }
        else {
            return true;
        }
    }
    else {
        return false;
    }
};
export const chargesHandler = (tradeValue) => {
    if (!tradeValue.quantity || !tradeValue.limitPrice) {
        return true;
    }
    return false;
};
export const handleLimitPriceValidation = (limitPrice, quotesDetails) => {
    if (!limitPrice) {
        return {
            status: true,
            msg: "Limit price can not be blank",
        };
    }
    else if (validateTickSize(limitPrice, quotesDetails.tickSize)) {
        return {
            status: true,
            msg: `Price should be multiple of Tick Size Which is ${quotesDetails.tickSize} Rupees for this contract`,
        };
    }
    else if (+limitPrice > +quotesDetails.higherCircuit) {
        return {
            status: true,
            msg: `Price can not be above ${quotesDetails.higherCircuit}`,
        };
    }
    else if (+limitPrice < +quotesDetails.lowerCircuit) {
        return {
            status: true,
            msg: `Price can not be less than ${quotesDetails.lowerCircuit}`,
        };
    }
    else {
        return {
            status: false,
            msg: "",
        };
    }
};
export const handleTriggerPriceValidation = (triggerPrice, limitPrice, activeState, quotesDetails) => {
    if (!triggerPrice || triggerPrice == "0") {
        return {
            status: true,
            msg: `Trigger price can not be blank or 0`,
        };
    }
    else if (validateTickSize(triggerPrice, quotesDetails.tickSize)) {
        return {
            status: true,
            msg: `Price should be multiple of Tick Size Which is ${quotesDetails.tickSize} Rupees for this contract`,
        };
    }
    else if (activeState === TOCBUYORSELL.BUY && +triggerPrice >= +limitPrice) {
        return {
            status: true,
            msg: "Trigger price should be less than limit price",
        };
    }
    else if (activeState === TOCBUYORSELL.BUY &&
        +triggerPrice <= +(quotesDetails === null || quotesDetails === void 0 ? void 0 : quotesDetails.lastTradedPrice)) {
        return {
            status: true,
            msg: "Trigger price should be greater than LTP",
        };
    }
    else if (activeState === TOCBUYORSELL.SELL &&
        +triggerPrice <= +limitPrice) {
        return {
            status: true,
            msg: "Trigger price should be greater than limit price",
        };
    }
    else if (activeState === TOCBUYORSELL.SELL &&
        +triggerPrice >= +(quotesDetails === null || quotesDetails === void 0 ? void 0 : quotesDetails.lastTradedPrice)) {
        return {
            status: true,
            msg: "Trigger price should be less than LTP",
        };
    }
    else {
        return {
            status: false,
            msg: "",
        };
    }
};
export const handleDiscloseQtyValidation = (disclosedQuantity, quantity) => {
    if (!!disclosedQuantity && !!quantity && +disclosedQuantity > +quantity) {
        return {
            status: true,
            msg: `Disclosed qty can not be greater than order quantity`,
        };
    }
    else if (!!disclosedQuantity &&
        !!quantity &&
        +quantity / 10 > +disclosedQuantity) {
        return {
            status: true,
            msg: `Disclosed qty can not be less than 10% of the order quantity`,
        };
    }
    else {
        return {
            status: false,
            msg: "",
        };
    }
};
export const handleDiscloseQtyValidationCO = (disclosedQuantity, quantity) => {
    if (!!disclosedQuantity && !!quantity && +disclosedQuantity > +quantity) {
        return {
            status: true,
            msg: `Disclosed qty can not be greater than order quantity`,
        };
    }
    else if (!!disclosedQuantity &&
        !!quantity &&
        +quantity / 4 > +disclosedQuantity) {
        return {
            status: true,
            msg: `Disclosed qty can not be less than 25% of the order quantity`,
        };
    }
    else {
        return {
            status: false,
            msg: "",
        };
    }
};
export const handleStoplossValidation = (stopLoss, limitPrice, activeState, quotesDetails) => {
    if (!stopLoss || stopLoss == "0") {
        return {
            status: true,
            msg: "Stop loss can not be blank or 0 ",
        };
    }
    else if (activeState === TOCBUYORSELL.BUY &&
        +limitPrice - +stopLoss < +(quotesDetails === null || quotesDetails === void 0 ? void 0 : quotesDetails.lowerCircuit)) {
        return {
            status: true,
            msg: "Stop loss can not be less than lower circuit",
        };
    }
    else if (activeState === TOCBUYORSELL.SELL &&
        +stopLoss + +limitPrice > +(quotesDetails === null || quotesDetails === void 0 ? void 0 : quotesDetails.higherCircuit)) {
        return {
            status: true,
            msg: "Stop loss can not be greater than higher circuit",
        };
    }
    else {
        return {
            status: false,
            msg: "",
        };
    }
};
export const handleTargetValidation = (target, limitPrice, activeState, quotesDetails) => {
    if (!target) {
        return {
            status: true,
            msg: "Target price can not be blank or 0 ",
        };
    }
    else if (activeState === TOCBUYORSELL.BUY &&
        +target + +limitPrice > +(quotesDetails === null || quotesDetails === void 0 ? void 0 : quotesDetails.higherCircuit)) {
        return {
            status: true,
            msg: "Target price can not be greater than higher circuit ",
        };
    }
    else if (activeState === TOCBUYORSELL.SELL &&
        +limitPrice - +target < +(quotesDetails === null || quotesDetails === void 0 ? void 0 : quotesDetails.lowerCircuit)) {
        return {
            status: true,
            msg: "Target price can not be less than lower circuit ",
        };
    }
    else {
        return {
            status: false,
            msg: "",
        };
    }
};
export const handleQuantityValidation = (quantity) => {
    if (!quantity || (quantity && +quantity <= 0)) {
        return {
            status: true,
            msg: `Qty can not be 0 or blank`,
        };
    }
    else {
        return {
            status: false,
            msg: ``,
        };
    }
};
export const eCollectBankDetails = [
    { key: "Beneficiary Name", value: "Edelweiss Brocking Ltd" },
    { key: "Beneficiary Bank", value: "Citibank" },
    { key: "Bank Branch", value: "Mumbai" },
    { key: "Account Type", value: "Current Account" },
    { key: "IFSC", value: "CITI0100000" },
    { key: "Beneficiary Bank A/c Number", value: "EBL145011037" },
];
export const fieldValidationManager = (tradeValue, activeState, quotesDetails) => {
    return {
        getLimitValidation: handleLimitPriceValidation(tradeValue.limitPrice, quotesDetails),
        getTriggerValidation: handleTriggerPriceValidation(tradeValue.triggerPrice, tradeValue.limitPrice, activeState, quotesDetails),
        getTargetValidation: handleTargetValidation(tradeValue.target, tradeValue.limitPrice, activeState, quotesDetails),
        getStoplossValidation: handleStoplossValidation(tradeValue.stopLoss, tradeValue.limitPrice, activeState, quotesDetails),
        getDisclossValidation: handleDiscloseQtyValidation(tradeValue === null || tradeValue === void 0 ? void 0 : tradeValue.disclosedQuantity, tradeValue === null || tradeValue === void 0 ? void 0 : tradeValue.quantity),
    };
};
